import * as React from 'react';
import { Box, darken, SpeedDial, SpeedDialAction, Tooltip, useTheme } from '@mui/material';

// Icons
import SettingsIcon from '@mui/icons-material/Settings';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useSearchParams } from 'react-router-dom';
import { ContextActionType, useContextActions } from '../../../providers/Actions';
import { useFullLayout } from '../../templates/FullLayout/FullLayoutContext';

type ContextActionsMenuProps = {
    mainIcon?: React.ReactNode;
    /** Couleur des icônes dans les actions */
    actionIconColor?: string;
};

export const ContextActionsMenu: React.FunctionComponent<ContextActionsMenuProps> = function (
    props,
) {
    const theme = useTheme();
    const { mainIcon = <SettingsIcon />, actionIconColor } = props;

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();
    const { toggleCustomizerDrawer } = useFullLayout();

    const openCustomizeFromProfile = (targetKey: string) => {
        setSearchParams((prev) => {
            prev.set('settingsTarget', targetKey);
            return prev;
        });

        toggleCustomizerDrawer();
    };

    const defaultActions: ContextActionType[] = [
        {
            name: 'Thème',
            icon: <FaOptionIcon icon={['fas', 'brush']} />,
            action: () => {
                openCustomizeFromProfile('themes');
            },
        },
    ];

    const { contextActions } = useContextActions();

    const actions = [...contextActions, ...defaultActions];

    const resolvedIconColor = actionIconColor ?? theme.palette.text.secondary;

    return (
        <SpeedDial
            data-testid="contextactionmenu"
            onOpen={() => null}
            onClick={handleOpen}
            open={open}
            ariaLabel="SpeedDial basic example"
            sx={{
                position: 'absolute',
                bottom: 16,
                right: 16,
                zIndex: 1600,
                '& .MuiButtonBase-root': {
                    backgroundColor: theme.palette.background.paper,
                },
                '& .MuiButtonBase-root:hover': {
                    backgroundColor: darken(theme.palette.background.paper, 0.12),
                },
            }}
            icon={
                <Tooltip
                    title={`${actions && actions.length ? actions.length : 0} action${actions && actions.length > 1 ? 's' : ''} disponible${actions && actions.length > 1 ? 's' : ''}`}
                >
                    <div>{mainIcon}</div>
                </Tooltip>
            }
        >
            {actions.map((actionItem: ContextActionType) => {
                const { action, name, icon } = actionItem;
                return (
                    <SpeedDialAction
                        key={name}
                        icon={
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: resolvedIconColor,
                                    '& svg': {
                                        color: resolvedIconColor,
                                    },
                                    '& .svg-inline--fa': {
                                        color: resolvedIconColor,
                                    },
                                }}
                            >
                                {icon}
                            </Box>
                        }
                        tooltipTitle={name}
                        onClick={action}
                    />
                );
            })}
        </SpeedDial>
    );
};
